import { useEffect, useMemo } from 'react';
import useLocation from '@klv/hooks/useLocation';

import type { IRefinementListItem } from '../types';

type TParams = [
  {
    items: IRefinementListItem[];
    refine: (value: string) => void;
  },
];

export default function useRefineQueryParams(...params: TParams) {
  const location = useLocation();

  const [
    { items, refine },
  ] = params;

  const searchParams = new URLSearchParams(location.search);
  const selectParam = decodeURIComponent(searchParams.get('select') ?? '');
  const paramValues = useMemo(() => selectParam.split('|') || [], [selectParam]);

  const unrefinedParamItems = items.filter(item => {
    return !item.isRefined && (
      paramValues.includes(item.value) || paramValues.includes(item.value.toLowerCase())
    );
  });

  // refine all unselected items from 'select' URL query param
  useEffect(() => {
    if (unrefinedParamItems.length > 0) {
      unrefinedParamItems.forEach(item => {
        if (item && !item.isRefined) {
          refine(item.value);
        }
      });
    }
  }, [refine, unrefinedParamItems]);
}
